import { db } from '@/globals'

// initial state
const state = () => ({
  errors: {},
  isThereError: false
})

// getters
const getters = {
  // isFieldValid: (state) => (field) => {
  //   return state.errors[field] === undefined || state.errors[field] == ''
  // },
}

// actions
const actions = {}

// mutations
const mutations = {
  setError(state, payload) {
    state.errors[payload.error.field] = payload.error.error
    // console.log('Payment validations', state.errors)

    // state.isThereError = false
    // Object.keys(state.errors).forEach(k => {
    //   if (state.errors[k] != '') {
    //     state.isThereError = true
    //   }
    // })
  },
  setValidationResult(state, payload) {
    state.isThereError = payload.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
